

































































































































































































import { Component, Vue } from "vue-property-decorator";
@Component
export default class Home extends Vue {
  private win = window;
  private base = window.location;

  private irLinkMobile() {
    var link = "https://api.whatsapp.com/send?phone=56951339354";
    window.open(link);
  }
}
